import React from "react";
import StudiosList from "../components/StudiosList";
import CatServicesList from "../components/CatServicesList";
import CheckoutButton from "../components/CheckoutButton";

const HomePage = () => {
  return (
    <div className="home-page__wrapper">
      <div className="mobile-head">
        <img className="mobile-head__logo" src="./img/Logo.png" alt="logo" />
        <p className="mobile-head__text">Choose a service and a beauty studio, and proceed to booking</p>
      </div>
      <div className="home-page">
        <StudiosList />
        <CatServicesList />
        <CheckoutButton />
      </div>
    </div>
  );
};

export default HomePage;
